<template>
    <v-dialog v-model="showDialog"
              class="idea-delete-dialog"
              min-width="300"
              transition="dialog-bottom-transition"
              width="auto">
        <v-card class="text-primary ma-0">
            <v-card-title>
                Подтвердите удаление
            </v-card-title>

            <v-card-text>
                Вы действительно хотите удалить идею <b>{{ idea.name }}</b>?
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn color="secondary"
                       variant="elevated"
                       @click="$emit('hide')">Отменить</v-btn>
                <v-btn color="error"
                       variant="elevated"
                       @click="deleteIdea">Удалить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            idea: {
                required: true,
                type: Object
            }
        },

        emits: ["hide"],

        data() {
            return {
                showDialog: true
            };
        },

        watch: {
            showDialog(newValue) {
                if (newValue === false) {
                    this.$emit("hide");
                }
            }
        },

        methods: {
            deleteIdea() {
                this.$store.dispatch("deleteIdea", this.idea.id)
                    .then(() => {
                        this.$store.dispatch("loadIdeas");
                        this.$emit("hide");
                    });
            }
        }
    };
</script>